import { render, staticRenderFns } from "./branch-card.vue?vue&type=template&id=8ffcc5ce&scoped=true&"
import script from "./branch-card.vue?vue&type=script&lang=js&"
export * from "./branch-card.vue?vue&type=script&lang=js&"
import style0 from "./branch-card.vue?vue&type=style&index=0&id=8ffcc5ce&lang=scss&scoped=true&"
import style1 from "./branch-card.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./branch-card.vue?vue&type=style&index=2&id=8ffcc5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffcc5ce",
  null
  
)

export default component.exports
import {QCard,QImg,QSpinnerIos,QCardSection,QCardActions,QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QImg,QSpinnerIos,QCardSection,QCardActions,QBtn,QIcon})
